export const FAMILY_SAUNA = "sauna"
export const FAMILY_GENERATORE_VAPORE = "generatore_vapore"
export const FAMILY_CABINA_HAMMAM = "cabina_hammam"
export const FAMILY_PORTE = "porte"
export const FAMILY_SISTEMA_INTEGRATO = "sistema_integrato_sauna_hammam"
export const FAMILY_ACQUA = "acqua"

export default [
    { value: FAMILY_SAUNA, label: 'product_types.sauna' },
    { value: FAMILY_GENERATORE_VAPORE, label: 'product_types.generatore_vapore' },
    { value: FAMILY_CABINA_HAMMAM, label: 'product_types.cabina_hammam' },
    { value: FAMILY_PORTE, label: 'product_types.porte' },
    { value: FAMILY_SISTEMA_INTEGRATO, label: 'product_types.sistema_integrato_sauna_hammam' },
    { value: FAMILY_ACQUA, label: 'product_types.acqua' },
]
